import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Heading } from "../../../design/heading";
import BusinessForm, {
  BusinessFormRef,
} from "../../../components/Forms/BusinessForm";
import { Button } from "../../../design/button";
import { Text } from "../../../design/text";
import { Card } from "../../../design/card";
import { BuildingOfficeIcon } from "@heroicons/react/20/solid";

const BusinessStep: React.FC = () => {
  const navigate = useNavigate();
  const formRef = useRef<BusinessFormRef>(null);
  const [isSaving, setIsSaving] = useState(false);

  const handleSubmit = async () => {
    if (formRef.current) {
      setIsSaving(true);
      await formRef.current.submitForm();
      setIsSaving(false);
    }
  };

  const handleStepComplete = () => {
    navigate("/onboarding/address");
  };

  return (
    <div className="max-w-2xl mx-auto space-y-6">
      {/* Header */}
      <div className="space-y-2 text-center">
        <div className="flex justify-center mb-4">
          <div className="p-3 bg-blue-100 dark:bg-blue-900/30 rounded-full">
            <BuildingOfficeIcon className="w-8 h-8 text-blue-600 dark:text-blue-400" />
          </div>
        </div>
        <Heading>Business Information</Heading>
        <Text className="text-lg text-gray-600 dark:text-gray-400">
          Let's start with your business details
        </Text>
      </div>

      {/* Info Card */}
      <Card className="bg-blue-50 dark:bg-blue-900/20 border-blue-200 dark:border-blue-800">
        <div className="flex items-start gap-3">
          <span className="flex-shrink-0 text-xl">ℹ️</span>
          <div className="text-sm text-gray-700 dark:text-gray-300">
            <Text>
              This information will be used to populate the fields on your reports and invoices.
            </Text>
          </div>
        </div>
      </Card>

      {/* Form */}
      <Card>
        <BusinessForm
          ref={formRef}
          isSaving={isSaving}
          onSuccessfulSubmit={handleStepComplete}
        />
      </Card>

      {/* Action Button */}
      <Button
        color="blue"
        className="w-full py-3 text-base font-semibold"
        onClick={handleSubmit}
        disabled={isSaving}
      >
        {isSaving ? "Saving..." : "Continue"}
      </Button>
    </div>
  );
};

export default BusinessStep;
